import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { T, BI, Img, SaveBar } from "./fields";

export default function HeroTab() {
    const [data, setData] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => { api.get("/admin/hero").then((r) => setData(r.data)).catch(() => toast.error("Failed to load hero")); }, []);
    if (!data) return <p className="text-sm text-neutral-500">Loading…</p>;

    const set = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
    const save = async () => {
        setSaving(true);
        try {
            await api.put("/admin/hero", data);
            toast.success("Hero saved");
        } catch {
            toast.error("Save failed");
        }
        setSaving(false);
    };

    return (
        <div className="max-w-3xl space-y-5" data-testid="hero-tab">
            <h2 className="font-display text-3xl">HERO VIDEO</h2>
            <T label="Hero Video URL (MP4 direct link, YouTube or Vimeo)" value={data.video_url} onChange={set("video_url")} testId="hero-video-url" />
            <Img label="Hero Poster Image URL (shown if video fails / while loading)" value={data.poster_url} onChange={set("poster_url")} testId="hero-poster-url" />
            <Img label="Hero Logo (image replaces the headline text — leave empty to use text)" value={data.logo_url} onChange={set("logo_url")} testId="hero-logo-url" />
            <div className="grid gap-5 sm:grid-cols-2">
                <BI label="Headline Line 1" value={data.headline_1} onChange={set("headline_1")} testId="hero-h1" />
                <BI label="Headline Line 2" value={data.headline_2} onChange={set("headline_2")} testId="hero-h2" />
            </div>
            <BI label="Tagline" value={data.tagline} onChange={set("tagline")} testId="hero-tagline" />
            <BI label="Supporting Text" value={data.subtext} onChange={set("subtext")} rows={2} testId="hero-subtext" />
            <div className="grid gap-5 sm:grid-cols-2">
                <BI label="Primary CTA Label" value={data.cta_primary_label} onChange={set("cta_primary_label")} testId="hero-cta1-label" />
                <T label="Primary CTA URL (#section or https://)" value={data.cta_primary_url} onChange={set("cta_primary_url")} testId="hero-cta1-url" />
                <BI label="Secondary CTA Label" value={data.cta_secondary_label} onChange={set("cta_secondary_label")} testId="hero-cta2-label" />
                <T label="Secondary CTA URL" value={data.cta_secondary_url} onChange={set("cta_secondary_url")} testId="hero-cta2-url" />
            </div>
            <SaveBar onSave={save} saving={saving} testId="hero-save-btn" />
        </div>
    );
}
